/**
 * TenderLens — web entry.
 *
 * Mounts React 19 + TanStack Query + TanStack Router under #root. The router
 * owns the auth boundary and app shell; this file is just plumbing.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { attachRefreshBanner } from './lib/attach-refresh-banner';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Network is local; aggressively cache to feel instant
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
});

// Spec §16 — surface row_version conflicts globally via the refresh banner.
attachRefreshBanner(queryClient);

const container = document.getElementById('root');
if (!container) throw new Error('#root element not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
